class JsonMap extends Map {
  constructor(map?: Map<string, string>) {
    super();

    if (map) {
      map.forEach((value: string, key: string) => {
        this.set(key, value);
      });
    }
  }

  toJSON() {
    const object = {};
    for (const [key, value] of this) object[key] = value;
    return object;
  }
}

export default JsonMap;
